import { defineComponent, Ref, inject, computed } from 'vue';
import { LocationModel, LocationStatus } from '@truckdown/locations';
import { locationKey } from '../keys';

import listingStatus from '../ListingStatus/ListingStatus.vue';

interface IData {
    editLocation: Ref<LocationModel>;
}

const getInitialData = (): IData => {
    const injectedLocation = inject<Ref<LocationModel>>(locationKey)!;
    return {
        editLocation: injectedLocation,
    };
};

const getComputed = (data: IData, props: any) => {
    return {
        locationStatus: computed(() => {
            return data.editLocation.value.status == LocationStatus.PendingApproval ? "Pending" : LocationStatus[data.editLocation.value.status];
        }),
        statusStyle: computed(() => {
            switch (data.editLocation.value.status) {
                case LocationStatus.PendingApproval:
                    return "td-badge primary slim"
                case LocationStatus.Active:
                    return "td-badge success slim"
                case LocationStatus.Purge:
                    return "td-badge danger slim"
                default:
                    return "td-badge slim"
            }
        }),
        editUrl: computed(() => {
            const adminSegment = props.isAdmin ? '/admin' : '';
            return `/listings${adminSegment}/view-location/${encodeURIComponent(data.editLocation.value.id)}#edit`;
        }),
        viewUrl: computed(() => {
            const adminSegment = props.isAdmin ? '/admin' : '';
            return `/listings${adminSegment}/view-location/${encodeURIComponent(data.editLocation.value.id)}`;
        }),
    };
};

const getMethods = (ctx: any) => {
    return {
        openEdit(type: string) {
            ctx.emit('open-edit', type);
        },
        openAccountMove(type: string) {
            ctx.emit('open-account-move', type);
        },
       
        showManageHours: function () {
            ctx.emit('open-hours');
        }
    };
};

export default defineComponent({
    props: {
        isAdmin: Boolean,
        editState: Boolean,
        hoursState: Boolean,
        selectedSite: String
    },
    name: "EditHeader",
    emits: ['open-edit', 'open-hours', 'open-account-move'],
    components: {
        'listing-status': listingStatus,
    },
    setup(props, ctx) {
        const data = getInitialData();
        const computed = getComputed(data, props);
        const methods = getMethods(ctx);

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});

